import { jsxs as r, jsx as C } from "react/jsx-runtime";
const e = ({ className: t }) => /* @__PURE__ */ r(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: t,
    children: [
      /* @__PURE__ */ r("g", { clipPath: "url(#clip0_387_16200)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M1.33203 12C1.33203 10.973 1.33203 10.4596 1.56318 10.0824C1.69253 9.87129 1.86999 9.69383 2.08105 9.56449C2.45826 9.33334 2.97174 9.33334 3.9987 9.33334C5.02566 9.33334 5.53914 9.33334 5.91634 9.56449C6.12741 9.69383 6.30487 9.87129 6.43421 10.0824C6.66536 10.4596 6.66536 10.973 6.66536 12C6.66536 13.027 6.66536 13.5404 6.43421 13.9176C6.30487 14.1287 6.12741 14.3062 5.91634 14.4355C5.53914 14.6667 5.02566 14.6667 3.9987 14.6667C2.97174 14.6667 2.45826 14.6667 2.08105 14.4355C1.86999 14.3062 1.69253 14.1287 1.56318 13.9176C1.33203 13.5404 1.33203 13.027 1.33203 12Z",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M9.33203 12C9.33203 10.973 9.33203 10.4596 9.56318 10.0824C9.69253 9.87129 9.86999 9.69383 10.0811 9.56449C10.4583 9.33334 10.9717 9.33334 11.9987 9.33334C13.0257 9.33334 13.5391 9.33334 13.9163 9.56449C14.1274 9.69383 14.3049 9.87129 14.4342 10.0824C14.6654 10.4596 14.6654 10.973 14.6654 12C14.6654 13.027 14.6654 13.5404 14.4342 13.9176C14.3049 14.1287 14.1274 14.3062 13.9163 14.4355C13.5391 14.6667 13.0257 14.6667 11.9987 14.6667C10.9717 14.6667 10.4583 14.6667 10.0811 14.4355C9.86999 14.3062 9.69253 14.1287 9.56318 13.9176C9.33203 13.5404 9.33203 13.027 9.33203 12Z",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M1.33203 4C1.33203 2.97304 1.33203 2.45956 1.56318 2.08236C1.69253 1.87129 1.86999 1.69383 2.08105 1.56449C2.45826 1.33334 2.97174 1.33334 3.9987 1.33334C5.02566 1.33334 5.53914 1.33334 5.91634 1.56449C6.12741 1.69383 6.30487 1.87129 6.43421 2.08236C6.66536 2.45956 6.66536 2.97304 6.66536 4C6.66536 5.02696 6.66536 5.54044 6.43421 5.91765C6.30487 6.12871 6.12741 6.30617 5.91634 6.43552C5.53914 6.66667 5.02566 6.66667 3.9987 6.66667C2.97174 6.66667 2.45826 6.66667 2.08105 6.43552C1.86999 6.30617 1.69253 6.12871 1.56318 5.91765C1.33203 5.54044 1.33203 5.02696 1.33203 4Z",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M9.33203 4C9.33203 2.97304 9.33203 2.45956 9.56318 2.08236C9.69253 1.87129 9.86999 1.69383 10.0811 1.56449C10.4583 1.33334 10.9717 1.33334 11.9987 1.33334C13.0257 1.33334 13.5391 1.33334 13.9163 1.56449C14.1274 1.69383 14.3049 1.87129 14.4342 2.08236C14.6654 2.45956 14.6654 2.97304 14.6654 4C14.6654 5.02696 14.6654 5.54044 14.4342 5.91765C14.3049 6.12871 14.1274 6.30617 13.9163 6.43552C13.5391 6.66667 13.0257 6.66667 11.9987 6.66667C10.9717 6.66667 10.4583 6.66667 10.0811 6.43552C9.86999 6.30617 9.69253 6.12871 9.56318 5.91765C9.33203 5.54044 9.33203 5.02696 9.33203 4Z",
            stroke: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_387_16200", children: /* @__PURE__ */ C("rect", { width: "16", height: "16", fill: "currentColor" }) }) })
    ]
  }
);
export {
  e as GridIcon
};
